import * as types from "../constants";

export function Login(userData: types.LoginAction): types.AuthActionsTypes {
    return {
        type: types.AUTH_LOGIN,
        payload: userData
    };
}
export function Logout(): types.AuthActionsTypes {
    return {
        type: types.AUTH_LOGOUT
    };
}
export function RefreshTokens(Tokens: types.IRefreshTokens): types.AuthActionsTypes {
    return {
        type: types.REFRESH_TOKENS,
        payload: Tokens
    };
}
export function UpdateZendeskID(ZendeskID: string): types.UpdateZendeskIDAction {
    return {
        type: types.UPDATE_ZENDESKID,
        payload: ZendeskID
    };
}
export function UpdateIsValid(isValid: boolean): types.UpdateIsValid {
    return {
        type: types.UPDATE_ISVALID,
        payload: isValid
    };
}